import React from 'react';
import { motion } from 'framer-motion';

const SplashLoader = () => {
    return (
        <div style={{ height: '100vh', backgroundColor: '#ffffff' }} className="d-flex justify-content-center align-items-center flex-column">
            <motion.div
                animate={{ scale: [1, 1.08, 1], opacity: [0.6, 1, 0.6] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
            >
                <img 
                    src="/app-logo.png" 
                    alt="BreakThrough Logo"
                    style={{ width: '140px', height: 'auto', objectFit: 'contain' }}
                />
            </motion.div>
        </div>
    );
};

export default SplashLoader;
